import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { actionUrl } from 'config/static-content';

export const PsrInfo = () => {
  return (
    <>
      <div>
        When you sign up to the PSR, we’ll store and manage your data on our
        secure systems. You can read more about how we use your information
        above in our{' '}
        <NsAnchor href={actionUrl.privacy}>Energy privacy notice</NsAnchor>.
      </div>
      <div>
        Sometimes, we’ll share it with those who supply and maintain the supply
        of electricity & gas to your home, including meter operators,
        engineering partners, network operators and water suppliers.
      </div>
    </>
  );
};
